<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="svg === 'delete'">
	<path
		d="M3.16699 5.54167H15.8337M15.042 5.54167L14.3556 15.1541C14.3272 15.5535 14.1484 15.9274 13.8554 16.2003C13.5623 16.4733 13.1767 16.625 12.7762 16.625H6.22441C5.82394 16.625 5.43834 16.4733 5.14528 16.2003C4.85222 15.9274 4.67347 15.5535 4.64503 15.1541L3.95866 5.54167H15.042ZM7.91699 8.70833V13.4583V8.70833ZM11.0837 8.70833V13.4583V8.70833ZM11.8753 5.54167V3.16667C11.8753 2.9567 11.7919 2.75534 11.6435 2.60687C11.495 2.45841 11.2936 2.375 11.0837 2.375H7.91699C7.70703 2.375 7.50567 2.45841 7.3572 2.60687C7.20873 2.75534 7.12533 2.9567 7.12533 3.16667V5.54167H11.8753Z"
		stroke="red"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
